import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const GENERIC_IMAGE_CLASS_NAME = 'GenericImage';
export const GENERIC_IMAGE_CLASS_SLOTS = [
	'root',
	'image',
	'imageWrapper',
	'customIcon',
	'skeleton',
	'watermark',
] as const;

export type GenericImageClassSlot = (typeof GENERIC_IMAGE_CLASS_SLOTS)[number];

export interface GenericImageClasses {
	root: string;
	customIcon: string;
	image: string;
	imageWrapper: string;
	skeleton: string;
	watermark: string;

	defaultIcon: string;
	landscape: string;
	portrait: string;
}

export type GenericImageClassKey = keyof GenericImageClasses;

export const getGenericImageUtilityClass = (slot: string) =>
	generateUtilityClass(GENERIC_IMAGE_CLASS_NAME, slot);

export const genericImageClasses = generateUtilityClasses<
	keyof GenericImageClasses
>(GENERIC_IMAGE_CLASS_NAME, [
	'root',
	'customIcon',
	'defaultIcon',
	'image',
	'imageWrapper',
	'landscape',
	'portrait',
	'skeleton',
	'watermark',
]);
export default genericImageClasses;
